<template>
    <div class="row">
        <div class="col-md-9">
            <Loading v-if="showLoading" />
            <div class="card mb-3">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات درخواست</div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover mb-0 order-table-details" v-if="request.domainData && Object.keys(request.domainData).length">
                            <tbody>
                                <tr>
                                    <td>شناسه درخواست:</td>
                                    <td>{{ $route.params.id }}</td>
                                    <td>سازمان درخواست دهنده:</td>
                                    <td>{{ request.domainData.fullName }}</td>
                                    <td>نوع درخواست:</td>
                                    <td>{{ request.type == 1 ? 'شارژ بن کارت' : 
                                    (request.type == 3 ? 'صدور رمز بن کارت' : 
                                    (request.type == 4 ? 'مسدودی بن کارت' : 
                                    request.type == 5 ? 'رفع مسدودی بن کارت' : 'شارژ کیف پول')) }}</td>
                                    <td>وضعیت:</td>
                                    <td>{{ request.flowStatus && request.flowStatus.flowStepStatus && request.flowStatus.flowStepStatus.title ? request.flowStatus.flowStepStatus.title : '-' }}</td>
                                </tr>
                                <tr v-if="request.description" style="border-left: 1px solid #262644">
                                    <td>دلیل عدم تایید:</td>
                                    <td colspan="5">{{ request.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card mb-3" v-if="request.type == 1 && cards.length">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">لیست کارت ها</div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>نام صاحب کارت</th>
                                    <th>کد ملی صاحب کارت</th>
                                    <th>شماره کارت</th>
                                    <th>مبلغ شارژ</th>
                                    <th>تاریخ درخواست</th>
                                    <th>تاریخ انجام</th>
                                    <th>وضعیت</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(card,index) in cards" :key="index">
                                    <td>{{ card.ownerCardName }}</td>
                                    <td>{{ card.ownerNationalCode }}</td>
                                    <td dir="ltr">{{ card.pan }}</td>
                                    <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(card.chargeAmount) }}</td>
                                    <td dir="ltr">{{ card.requestDate }}</td>
                                    <td dir="ltr">{{ card.chargeDate }}</td>
                                    <td>{{ card.orderType }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card mb-3" v-if="transactions.length">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">لیست پرداخت ها</div>
                <div class="card-body">
                    <table class="table table-bordered table-hover mb-0">
                        <thead>
                            <tr>
                                <th>مبلغ</th>
                                <th>شماره مرجع</th>
                                <th>شماره پیگیری</th>
                                <th>وضعیت</th>
                                <th>تاریخ</th>
                                <th>تصویر رسید</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(transaction,index) in transactions" :key="index">
                                <th>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.amount || 0) + ' ریال' }}</th>
                                <th>{{ transaction.trRrn || '-' }}</th>
                                <th>{{ transaction.trPaymentid || '-' }}</th>
                                <th v-if="transaction.transactionStatusId == 2"><span class="badge badge-success">موفق</span></th>
                                <th v-else><span class="badge badge-danger">ناموفق</span></th>
                                <th>{{ new Date(transaction.createdAt).toLocaleTimeString('fa-ir') + ' - ' + new Date(transaction.createdAt).toLocaleDateString('fa-ir') }}</th>
                                <th v-if="transaction.receiptId"><a @click="openReceipts(transaction.transactionId)" target="_blank" style="cursor: pointer">کلیک کنید</a></th>
                                <th v-else>-</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card mb-3" v-if="(!$store.state.userData.isOrganization && !$store.state.userData.isPishkhan) && ((request.flowStepStatusId == 21 && $store.state.role == 'finance') || request.flowStepStatusId == 4)">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">عملیات</div>
                <div class="card-body">
                    <button class="btn btn-success btn-block" @click="financialApprove" v-if="$store.state.role == 'finance' && request.flowStepStatusId == 21 && !request.financeVerify">تاییدیه مالی</button>
                    <button class="btn btn-danger btn-block" data-target="#finance-reject" data-toggle="modal" v-if="$store.state.role == 'finance' && request.flowStepStatusId == 21 && !request.financeVerify">عدم تایید مالی</button>
                    <button class="btn btn-success btn-block" @click="approveRequest" v-if="request.flowStepStatusId == 4 || request.type == 3">تایید درخواست</button>
                    <button class="btn btn-danger btn-block" data-toggle="modal" data-target="#request-reject" v-if="request.flowStepStatusId == 4 || request.type == 3">رد درخواست</button>
                </div>
            </div>
            <div class="card mb-3" v-if="$store.state.userData.isOrganization && request.flowStepStatusId == 1 && !request.financeVerify && false">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">پرداخت هزینه سفارش</div>
                <div class="card-body">
                    <div class="alert alert-primary">
                        <p class="mb-0">میزان موجودی کیف پول : <b>{{ deposit }} ریال</b></p>
                    </div>
                    <button class="btn btn-success btn-block" :disabled="request.totalAmount > parseInt(deposit.toString().replace(/,/g,''))" @click="walletSubmitPayment">پرداخت از کیف پول</button>
                    <button class="btn btn-warning btn-block" @click="chargeDeposit" v-if="request.totalAmount > parseInt(deposit.toString().replace(/,/g,''))">افزایش موجودی کیف پول ({{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(request.totalAmount - parseInt(deposit.toString().replace(/,/g,''))) }} ریال)</button>
                </div>
            </div>
            <div class="card mb-3" v-if="request.flowStepStatusId == 1 && !request.financeVerify">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">ثبت اطلاعات پرداخت</div>
                <form class="card-body" v-on:submit.prevent="submitPayment">
                    <div class="form-group">
                        <label>شناسه پرداخت / شماره پیگیری</label>
                        <input type="tel" class="form-control ltr-input" v-model="paymentIdentifier">
                    </div>
                    <div class="form-group">
                        <label>شماره ارجاع / شماره درخواست</label>
                        <input type="tel" class="form-control ltr-input" v-model="rrn">
                    </div>
                    <div class="form-group">
                        <label>تصویر فیش واریزی</label>
                        <div class="input-group file-browser">
                            <input id="file-input" type="text" class="form-control border-left-0 browse-file" placeholder="انتخاب کنید" readonly="">
                            <label class="input-group-btn">
                                <span class="btn btn-primary">
                                    انتخاب <input type="file" style="display: none;" accept="image/jpeg" @change="setFile">
                                </span>
                            </label>
                        </div>
                    </div>
                    <button class="btn btn-success btn-block">ثبت اطلاعات</button>
                </form>
            </div>
            <div class="card mb-3">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات مالی</div>
                <div class="card-body">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ سفارش:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(request.amount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between" v-if="request.discount != 0">
                        <div class="m-1">
                            <span>مبلغ تخفیف:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(request.discount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ کل:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(request.totalAmount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>وضعیت پرداخت:</span>
                        </div>
                        <div class="m-1">
                            <span v-if="request.financeVerify" class="badge badge-success">پرداخت شده</span>
                            <span v-else class="badge badge-danger">پرداخت نشده</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="request-reject" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">علت عدم تایید</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>توضیحات</label>
                                    <textarea rows="4" class="form-control" v-model="description"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-success" @click="rejectRequest" data-dismiss="modal">ثبت عدم تایید</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="finance-reject" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">علت عدم تایید</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>توضیحات</label>
                                    <textarea rows="4" class="form-control" v-model="financeRejectDescription"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-success" @click="financialReject" data-dismiss="modal">ثبت عدم تایید</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RequestsShow',
    data(){
        return {
            showLoading: true,
            paymentIdentifier: '',
            rrn: '',
            amount: 0,
            file: '',
            title: '',
            deposit: 0,
            discount: null,
            description: '',
            transactions: [],
            cards: [],
            financeRejectDescription: '',
            request: {}
        }
    },
    methods: {
        getData(){
            if(this.$store.state.userData.hasWallet){
                this.$api.get('Organizations/Wallet/Balance').then(({data}) => {
                    if(data.status)
                        this.deposit = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(data.result);
                }).finally(() => {
                    this.showLoading = false;
                });
            }
            this.$api.get('Organizations/Bonus/Request?RequestId=' + this.$route.params.id).then(({data}) => {
                this.request = data.result;
                if(data.result.type == 1){
                    this.$api.post('Organizations/Bonus/SearchChargeOrders',{offset: 1,limit: 500,chargeOrderId: this.$route.params.id}).then(res => {
                        const response = res.data;
                        if(response.status)
                            this.cards = response.result.result;
                    }).finally(() => {
                        this.showLoading = false;
                    })
                }
                this.transactions = this.request.transactions;
            }).finally(() => {
                if(this.request.type != 1)
                    this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('file-input').setAttribute('placeholder',file.name);
        },
        openReceipts(id){
            window.open('https://cardapi.sabinarya.com/api/v1/Management/Receipts/' + id);
        },
        chargeDeposit(){
            let amount = this.request.totalAmount - parseInt(this.deposit.toString().replace(/,/g,''));
            localStorage.setItem('amount',amount);
            this.$router.push({name: 'organization.wallet'});
        },
        approveRequest(){
            this.showLoading = true;
            this.$api.post('Organizations/Bonus/Request/Approve',{requestId: parseInt(this.$route.params.id),approve: true}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تایید درخواست با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        rejectRequest(){
            this.showLoading = true;
            this.$api.post('Organizations/Bonus/Request/Approve',{requestId: parseInt(this.$route.params.id),approve: false,description: this.description}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'رد درخواست با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        financialApprove(){
            this.showLoading = true;
            this.$api.post('Organizations/Bonus/Request/FinancialApprove',{requestId: parseInt(this.$route.params.id),confirm: true}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تایید مالی درخواست با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        financialReject(){
            this.showLoading = true;
            this.$api.post('Organizations/Bonus/Request/FinancialApprove',{requestId: parseInt(this.$route.params.id),confirm: false,description: this.financeRejectDescription}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'عدم تایید مالی درخواست با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submitPayment(){
            this.showLoading = true;
            const postedData = {
                requestId: this.$route.params.id,
                paymentIdentifier: this.paymentIdentifier,
                rrn: this.rrn,
                title: this.title,
                base64Receipt: this.file
            };
            this.$api.post('Organizations/Bonus/Request/Payment',postedData).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.paymentIdentifier = this.amount = this.rrn = this.pansFile = '';
                    document.getElementById('file-input').setAttribute('placeholder','');
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت اطلاعات پرداخت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'ثبت اطلاعات پرداخت ناموفق بود',
                        confirmButtonText: 'متوجه شدم'
                    });
            }).catch(({response}) => {
                this.showLoading = false;
            });
        },
        walletSubmitPayment(){
            this.showLoading = true;
            this.$api.post('Organizations/Bonus/Charge/WalletPayment',{requestId: this.$route.params.id}).then(({data}) => {
                if(data.status){
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'پرداخت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>